import LoadingButton from './LoadingButton';

export default function ComponentsOverrides(theme) {
  return Object.assign(LoadingButton(theme));
}
